<span class="selected-option" *ngIf="!isOpen" (click)="startEditing(filterField!)">
  {{filterField! | translate}}
  <button type="button" *ngIf="deletable" class="btn delete" (click)="onDeleteFilter()">
    <i class="fa fa-times d-flex justify-content-center align-items-center"></i>
  </button>
</span>
<ado-core-filter-datepicker-field *ngIf="isOpen" adoCoreFilterDatepickerFocus #datepickerField
  [componentRefDate]="datepickerField" (stopEditingDate)="stopEditingDate($event)" [initialValue]="filterField"
  [placeholder]="placeholder!" (dateSelected)="onSelectChange($event)">
</ado-core-filter-datepicker-field>